"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const theme_1 = __importDefault(require("../../styles/theme"));
const constants_1 = require("../../constants/constants");
const screenWidth = react_native_1.Dimensions.get('screen').width;
const styles = react_native_1.StyleSheet.create({
    cardBackground: {
        backgroundColor: theme_1.default.colors.COLOR_GRAY_LIGHT,
        borderRadius: 6,
        borderWidth: 0.6,
        borderColor: theme_1.default.colors.COLOR_GRAY,
    },
    cardConnectBackground: {
        backgroundColor: theme_1.default.colors.COLOR_PRIMARY,
        borderRadius: 6,
        margin: react_native_1.Platform.OS === 'web' && screenWidth > constants_1.BREAK_POINT_WIDTH ? 15 : 10,
        marginVertical: react_native_1.Platform.OS === 'web' && screenWidth > constants_1.BREAK_POINT_WIDTH ? 0 : 40,
        paddingHorizontal: 30,
        paddingVertical: 20,
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'center',
        textAlignVertical: 'center',
    },
});
exports.default = styles;
